/**
 * This file imports Ramda and makes it available globally as 'R'
 * This is to fix the "R.filter is not a function" error in autocomplete.js
 */

import * as R from 'ramda';

// Make Ramda available globally
window.R = R;

export default R;